function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocieties(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 423.803 423.803",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80D440"
    },
    d: "M131.751,134.501h96l44,152.8h-140V134.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC729"
    },
    d: "M103.751,110.501l-32-12l-28,32l20,40l-43.6,21.2l-8.4,42.8h92l16-44L103.751,110.501z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C89406"
    },
    d: "M69.751,182.901c-1.2,0-2.4-0.4-3.6-0.8c-15.6-8.4-26.4-28.8-26.4-51.2s18-40.4,40.4-40.4 c6.8,0,12.8,1.6,18.8,4.4c4,2,5.6,6.8,3.6,10.8s-6.8,5.6-10.8,3.6s-7.2-2.8-11.6-2.8c-13.6,0-24.4,10.8-24.4,24.4 c0,16,7.6,31.6,17.6,36.8c4,2,5.2,6.8,3.2,10.8C75.351,181.301,72.551,182.901,69.751,182.901z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C89406"
    },
    d: "M54.151,242.101h-40.4c-4.4,0-8.8-2-11.2-5.6s-3.2-7.6-2-11.6l6.4-23.2c8-26,26.4-32.4,46.4-37.2 c4.4-1.2,8.8,1.6,9.6,6c1.2,4.4-1.6,8.8-6,9.6c-20,4.8-29.6,10-34.8,26l-5.6,20h37.6c4.4,0,8,3.6,8,8 S58.551,242.101,54.151,242.101z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80D440"
    },
    d: "M258.551,298.501h-209.6c-6,0-10.8-6-8.8-12l10.8-37.6c10.4-34.8,34.4-44.4,66.8-52"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6EA62A"
    },
    d: "M258.551,306.501h-209.6c-5.6,0-10.8-2.8-14-7.2c-3.2-4.4-4-10-2.4-15.2l10.8-37.2 c12-40.4,41.2-50.4,72.4-57.6c4.4-1.2,8.8,1.6,9.6,6c1.2,4.4-1.6,8.8-6,9.6c-33.6,8-52.4,17.2-60.8,46.4l-10.8,37.6 c0,0.4-0.4,0.8,0,1.2c0,0.4,0.4,0.8,1.2,0.8h209.6c4.4,0,8,3.6,8,8S262.951,306.501,258.551,306.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80D440"
    },
    d: "M132.951,208.101c-21.2-12.8-36-43.2-36-75.6c0-31.6,25.6-56.8,56.8-56.8c11.2,0,22,3.2,30.8,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6EA62A"
    },
    d: "M132.951,216.101c-1.6,0-2.8-0.4-4-1.2c-24-14.4-40-47.6-40-82.4c0-35.6,29.2-64.8,64.8-64.8 c12.4,0,24.8,3.6,35.2,10c3.6,2.4,4.8,7.2,2.4,11.2c-2.4,3.6-7.2,4.8-11.2,2.4c-7.6-4.8-17.2-7.6-26.4-7.6 c-26.8,0-48.8,22-48.8,48.8c0,29.2,13.2,57.2,32,68.8c3.6,2.4,4.8,7.2,2.8,10.8C138.151,214.901,135.751,216.101,132.951,216.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80D440"
    },
    d: "M255.751,230.501l16,60"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6EA62A"
    },
    d: "M271.751,298.501c-3.6,0-6.8-2.4-7.6-6l-16-60c-1.2-4.4,1.2-8.8,5.6-9.6c4.4-1.2,8.8,1.6,9.6,5.6 l16,60c1.2,4.4-1.2,8.8-5.6,9.6C272.951,298.501,272.551,298.501,271.751,298.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6913C"
    },
    d: "M163.751,120.501c0-45.6,36.8-82.4,82.4-82.4s82.4,36.8,82.4,82.4c0,60.4-36.8,118-82.4,118 S163.751,181.301,163.751,120.501L163.751,120.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF793B"
    },
    d: "M346.951,386.101h-253.6c-9.6,0-16.4-9.2-14-18.4l16.8-58.4c8.8-30.4,32.8-54,63.6-62l4.8-1.2l0,0 c4.4-1.2,9.2,0.4,12.4,4c19.2,22,43.6,24.4,69.6,24.4s50.4-2.4,69.6-24.4c3.2-3.6,8-5.2,12.4-4l0,0l5.2,1.2 c30.8,8,54.8,31.6,63.6,62l7.2,24.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6490F"
    },
    d: "M346.951,394.101h-253.6c-6.8,0-13.6-3.2-17.6-8.8c-4.4-5.6-6-12.8-4-19.6l16.8-58.4 c9.6-33.2,36-58.8,69.2-67.6l4.8-1.2c7.2-2,15.2,0.4,20.4,6.4c17.6,20,40,21.6,63.6,21.6s46-1.6,63.6-21.6c5.2-6,13.2-8.4,20.4-6.4 l4.8,1.2c33.2,8.8,60,34.4,69.6,67.6l7.2,24.8c1.2,4.4-1.2,8.8-5.6,10s-8.8-1.2-10-5.6l-7.2-24.8c-8-27.6-30-49.2-58-56.4l-4.8-1.2 c-1.6-0.4-3.6,0-4.8,1.6c-21.6,24.8-48.8,26.8-75.2,26.8s-53.6-2-75.6-27.2c-1.2-1.2-2.8-2-4.4-1.6l-4.8,1.2 c-27.6,7.2-50,28.8-58,56.8l-16.8,58.4c-0.4,2,0,4,1.2,5.6c0.8,0.8,2.4,2.4,5.2,2.4h253.6c4.4,0,8,3.6,8,8 S351.351,394.101,346.951,394.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF793B"
    },
    d: "M333.351,386.101h67.6c9.6,0,16.4-9.2,14-18.4l-16.8-58.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6490F"
    },
    d: "M400.951,394.101h-67.6c-4.4,0-8-3.6-8-8s3.6-8,8-8h67.6c2.8,0,4.4-1.6,5.2-2.4c1.2-1.6,1.6-4,1.2-6 l-16.8-58.4c-1.2-4.4,1.2-8.8,5.6-10s8.8,1.2,10,5.6l16.8,58.4c2,7.2,0.4,14.4-4,20 C414.551,390.901,407.751,394.101,400.951,394.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C47615"
    },
    d: "M327.751,109.701c-2.8,64.8-42.8,124.8-92,124.8c23.2-18.4,42.8-62.4,51.2-132 C314.151,110.901,327.751,107.301,327.751,109.701L327.751,109.701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A46210"
    },
    d: "M245.751,246.501c-48.8,0-90-57.6-90-126c0-2.4,0-4.8,0.4-7.6c0.8-4.4,5.2-7.2,9.6-6.4 c4.4,0.8,7.2,5.2,6.4,9.6c-0.4,1.2-0.4,2.8-0.4,4.4c0,58.4,34.4,110,74,110s74.4-51.6,74.4-110c0-4.4-0.4-8.8-1.2-12.4 c-0.8-4.4,2-8.4,6.4-9.2s8.4,2,9.2,6.4c0.8,4.8,1.2,10,1.2,15.6C336.151,187.701,293.751,246.501,245.751,246.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3030"
    },
    d: "M163.751,114.501c3.2-42.8,38.8-76.4,82-76.4c40.8,0,74.4,29.6,81.2,68.4c0,0-34.8,4.4-50.4-18 l-1.2,2.8c-12.8,25.6-53.6,38.8-105.6,27.2L163.751,114.501L163.751,114.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M206.151,130.901c-12,0-24.8-1.6-38.4-4.4l-1.6-0.4l-10.8-7.6l0.4-4.8c3.6-46.8,43.2-84,90-84 c44,0,81.6,31.6,89.2,75.2l1.6,8.4l-8.4,1.2c-1.2,0-30.4,3.6-49.6-12.4C264.551,120.501,238.551,130.901,206.151,130.901z  M172.951,110.901c44.4,9.6,83.2,0,95.2-23.2l6.8-16l8.4,12c8.4,12,24,14.4,33.6,14.8c-9.6-31.2-38-52.8-71.2-52.8 c-37.2,0-68.4,28-73.6,64.4L172.951,110.901z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocieties);
export default __webpack_public_path__ + "static/media/Societies.3a7070def1c7f4c236ce0b6dff5a353b.svg";
export { ForwardRef as ReactComponent };